module.exports = __webpack_public_path__ + "static/why-us-2-811237518072ffa982fe6bda03143e4a.jpg";